import Icon from "@ant-design/icons";
import { ReactComponent as NotificationSvg } from "./svg/notification.svg";

const NotificationIcon = (props) => (
	<Icon component={NotificationSvg} {...props} />
);

export default NotificationIcon;
